import { render, staticRenderFns } from "./InsuranceStatusTable.vue?vue&type=template&id=a5e05164"
import script from "./InsuranceStatusTable.vue?vue&type=script&lang=js"
export * from "./InsuranceStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports